module.exports = __webpack_public_path__ + "img/mdiCarHatchback.731910f7.svg";